import { SubmissionError } from 'redux-form';

import request from '@utils/request';

import { setMenuState } from '@actions/loginMenu';
import {
  hideLoadingModal,
  showLoadingModal,
} from '@actions/loadingModal';

const PREFIX = '[AUTH]';

export const LOGIN_REQUEST = `${PREFIX} LOGIN_REQUEST`;
export const LOGIN_SUCCESS = `${PREFIX} LOGIN_SUCCESS`;
export const LOGIN_FAILURE = `${PREFIX} LOGIN_FAILURE`;

const loginRequest = () => ({
  type: LOGIN_REQUEST,
});

const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

const loginFailure = () => ({
  type: LOGIN_FAILURE,
});

export const login = payload => (dispatch) => {
  dispatch(loginRequest());
  showLoadingModal(dispatch);

  return request
    .post('v1/token/', payload)
    .then(({ data: { token } = {} }) => {
      dispatch(loginSuccess());
      dispatch(setMenuState(false));
      request.setAuthToken(token);
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(loginFailure());
      throw new SubmissionError(data);
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const LOGOUT_SUCCESS = `${PREFIX} LOGOUT_SUCCESS`;

const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const logout = () => (dispatch) => {
  dispatch(logoutSuccess());
  request.setAuthToken();
  window.location.reload();
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js